import { userHasSpecificRestrictedFeatures } from '@/scripts/helper';
import Store from '@/vuex/store';


export function isRenewalReadOnly (productType, controlName, renewalMarket, hasActiveRateLock) {
    let hasPermission = false;
    if (renewalEditablePermissionsList.includes(controlName)) {
        Store.dispatch('resource/getRestrictedFeatures');
        const permissions = userHasSpecificRestrictedFeatures(['Endorsements_PolicyCorrections']) || [];
        hasPermission = permissions.some(p => renewalPermissionsList.includes(p));
    }

    if (productType === 'flood') {
        const excludedMarketList = excludedMarkets[renewalMarket] || [];
        if (hasActiveRateLock && activeRateLockReadOnly.includes(controlName)) { return true; }

        if (renewalEditablePermissionsList.includes(controlName) && hasPermission) {
            return false;
        }

        const returnValue = floodReadOnlyList.includes(controlName) && !excludedMarketList.includes(controlName);
        return returnValue;
    } else {
        let customerType = Store.getters.getSubmissionDataValue('CustomerType');

        if (renewalEditablePermissionsList.includes(controlName) && customerType === 'individual' && hasPermission) {
            return false;
        }
        return homeownersReadOnlyList.includes(controlName);
    }
}

const floodReadOnlyList = [
    'Risk',
    'EffectiveDate',
    'ExpirationDate',
    'FirstName',
    'LastName',
    'CoApplicant',
    'CoApplicantFirstName',
    'CoApplicantLastName',
    'CustomerType',
    'EntityName',
    'PrimaryApplicantFirstName',
    'PrimaryApplicantLastName',
    'SecondaryApplicant',
    'SecondaryApplicantFirstName',
    'SecondaryApplicantLastName',
    'BuildingValuationAmount',
    'RateLock',
    'FloodReady',
    'FloodFlex'
];
const activeRateLockReadOnly = [
    'RateLock',
    'FloodReady',
    'FloodFlex',
    'FloodFlexPercentage'
];
const homeownersReadOnlyList = [
    'Risk',
    'EffectiveDate',
    'ExpirationDate',
    'FirstName',
    'LastName',
    'CustomerType'
];

const excludedMarkets = {
    "BHSI": [
        'RateLock',
        'FloodReady',
        'FloodFlex',
        'FloodFlexPercentage'
    ],
    "AccessAlphaFlood": [
        // 'FloodReady',
        // 'FloodFlex'
    ]
};

const renewalEditablePermissionsList = [
    'FirstName',
    'LastName',
    'EntityName'
];

const renewalPermissionsList = [
    'Endorsements_PolicyCorrections'
];
